export default __webpack_public_path__ + "static/media/gallery_21.a627f34b.jpg";